<template>
  <div class="scale-region">
    <el-radio-group v-model="type" size="small" @change="selectradio">
      <el-radio-button :label="1">单个区县</el-radio-button>
      <el-radio-button :label="2">&nbsp;跨区县&nbsp;</el-radio-button>
      <el-radio-button :label="3">&nbsp;&nbsp;跨市&nbsp;&nbsp;</el-radio-button>
    </el-radio-group>
    <!-- <p style="margin:10px 0">注：所属区划决定了备案流程，请确定后操作</p> -->
    <p style="margin:10px 0">注：请选择申报单位所在的区县信息</p>
    <p v-for="(m, i) in region" :key="m.id" style="margin:22px 0">
      <!-- <el-select v-model="m.city" @change="selcity(i)" placeholder="市" clearable> -->
      <el-select v-model="m.city" @change="selcity(i)" placeholder="市">
        <el-option :value="v.code" v-for="v in cityList" :label="v.name" :key="v.code"></el-option>
      </el-select>
      <!-- <el-select v-model="m.county" @change="result(i)" v-show="type==1" placeholder="区县" clearable> -->
      <el-select v-model="m.county" @change="result(i)" v-show="type==1" placeholder="区县">
        <el-option :value="v.code" v-for="v in countyList" :label="v.name" :key="v.code"></el-option>
      </el-select>
      <!-- <el-select v-model="m.countys" @change="result(i)" multiple v-show="type!=1" placeholder="区县" clearable> -->
      <el-select v-model="m.countys" @change="result(i)" multiple v-show="type!=1" placeholder="区县">
        <el-option :value="v.code" v-for="v in countyList" :label="v.name" :key="v.code"></el-option>
      </el-select>
      <el-button style="margin-left:20px" v-if="type==3" icon="delete" type="text" @click="removeRegion(i)"></el-button>
    </p>
    <p v-if="type==3">
      <el-button @click="addRegion" type="text">添加</el-button>
    </p>
  </div>
</template>
<script>
import regions from '../../data/basic/region/region'
export default {
  props: {
    defaultObj: {
      type: Object
    },
    isUpdata: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 区划类型
      type: 1,
      // 区划列表
      region: [{
        city: '',
        county: '',
        countys: []
      }],
      // 城市列表
      cityList: [],
      countyList: [],
      // 数据模型
      dataModel: {
        city: {
          code: ''
        },
        county: [{
          code: ''
        }]
      },
      defaultTree: [],
      isComsChange: true,
    }
  },

  created() {
    this.getCountyList()
  },
  methods: {
    // 类型切换
    selectradio(val) {
      this.countyList = []
      this.region.splice(0)
      if (val == 3) {
        this.addRegion()
        this.addRegion()
        if (val === this.defaultObj.regionType) {
          this.setDefaultValue()
        }
      } else {
        this.addRegion()
        if (val === this.defaultObj.regionType) {
          this.setDefaultValue()
        }
      }
      this.$emit('changeIdval', val)
    },
    // 移除跨市区划
    removeRegion(num) {
      if (num == 0 || num == 1) {
        this.$message.error('请至少保留两个所属区划')
        return
      } else {
        this.region.splice(num, 1);
      }
    },
    // 添加跨市区划
    addRegion() {
      let model = {}
      model.city = ''
      model.county = ''
      model.countys = []
      this.region.push(JSON.parse(JSON.stringify(model)))
    },
    // 监听城市变动
    selcity(num) {
      let currCode = this.region[num].city,
        arr = [];
      for (let i = 0; i < this.cityList.length; i++) {
        if (this.cityList[i].code == currCode) {
          arr = this.cityList[i].children
          break
        }
      }
      this.countyList = arr
      //过滤
      var countyListCodes=this.countyList.map(element=>element.code)
      if(countyListCodes){
        var tempCountys = [];
        this.region[num].countys.forEach(code =>{
          if(countyListCodes.includes(code)){
            tempCountys.push(code)
          }
        });
        this.region[num].countys = tempCountys;
        if(!countyListCodes.includes(this.region[num].county)){
          this.region[num].county = countyListCodes[0]?countyListCodes[0]:'';
        }
      }
      if (this.type === 3 && this.isComsChange) {
        this.region[num].countys = []
      }

      if (this.defaultObj.regions) {
        if (num === this.defaultObj.regions.length - 1) {
          this.isComsChange = true
        }
      }
    },
    setValueData(val){
      if (val) {
        this.region= [{
            city: val.city,
            county:val.county,
            countys: []
          }]
      }
    },
    setDefaultValue(){
      if (!this.defaultObj.regionType) return
      this.isComsChange = false
      // 修改
      if (this.isUpdata) {
        this.type = this.defaultObj.regionType
        if (this.defaultObj.regionType === 1) {
          this.region[0].city = this.defaultObj.city.code
          this.getEditCountyList(this.defaultObj.city.code)
          this.region[0].county = this.defaultObj.county[0].code
        }
        if (this.defaultObj.regionType === 2) {
          this.region[0].city = this.defaultObj.city.code
          let countys = []
          for (let i = 0; i < this.defaultObj.county.length; i++) {
            if(this.defaultObj.county[i].code){
              countys.push(this.defaultObj.county[i].code)
            }
          }
          this.region[0].countys = countys
        }
        if (this.defaultObj.regionType === 3) {
          let arr = []
          if (this.defaultObj.regions) {
            for (let i = 0; i < this.defaultObj.regions.length; i++) {
              let countyArr = []
              for (let k = 0; k < this.defaultObj.regions[i].county.length; k++) {
                  if(this.defaultObj.regions[i].county[k].code){
                    countyArr.push(this.defaultObj.regions[i].county[k].code)
                  }
              }
              arr.push({
                city: this.defaultObj.regions[i].city.code,
                county: '',
                countys: countyArr
              })
            }
            this.region = arr
          }
        }
      }
    },
    // 监听区县变动
    result(num) {
    },
    // 获取区县列表
    getCountyList() {
      (async() => {
        let statelist = await regions.get_tree()
        if (statelist.status) {
          let pro = statelist.data;
          this.defaultTree = pro
          this.cityList = pro[0]['children'];
          //初始化控件
          this.setDefaultValue()
        } else {
          this.$message.error('网络不稳定，请稍候刷新重试')
        }
      })()
    },
    getEditCountyList(code) {
      for (let i = 0; i < this.defaultTree.length; i++) {
        if (this.defaultTree[i].code === code) {
          this.cityList = this.dataefaultTree[i]['children'];
          break
        }
      }
    },
    // 数据预处理
    get_datalist() {
      if (this.type == 1) {
        if(this.region[0].county){
          this.region[0].countys[0] = this.region[0].county
        }
      }
      this.format_data(this.region)
    },
    // 格式化数据
    format_data(data) {
      let boxAll = []
      let round = (data, box) => {
        for (let i = 0; i < data.length; i++) {
          box[i] = {}
          deal(data[i], box[i])
        }
      }
      let deal = (data, box) => {
        if(!data){
          box.city = {}
          box.county = []
        }else{
          if (data.city) {
            box.city = {}
            box.city.code = data.city
            box.county = []
            if(data.countys && data.countys.length > 0){
              round(data.countys, box.county)
            }
          } else {
            if(typeof(data)=='number') {
              box.code = data
            }else {
              box.city = {}
              box.city.code = data.city
              box.county = []
            }
          }
        }
      }
      round(data, boxAll)

      this.$emit('change', boxAll)
    }
  }
}

</script>
<style scoped>
.scale-region {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// ScaleRegion.vue?068a62f1